module.exports = __webpack_public_path__ + "static/m_how_it_works_fun_art@2x-2f357e8063100635a70ace6fe2e9a567.png";